var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/heart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0822 30.204C16.6565 30.204 16.2446 30.149 15.9013 30.0255C10.6562 28.2268 2.32178 21.842 2.32178 12.4091C2.32178 7.60341 6.20753 3.70392 10.9858 3.70392C13.3062 3.70392 15.4757 4.61014 17.0822 6.23035C18.6886 4.61014 20.8581 3.70392 23.1785 3.70392C27.9568 3.70392 31.8425 7.61714 31.8425 12.4091C31.8425 21.8558 23.5081 28.2268 18.263 30.0255C17.9197 30.149 17.5078 30.204 17.0822 30.204ZM10.9858 5.76351C7.34717 5.76351 4.38137 8.74304 4.38137 12.4091C4.38137 21.7871 13.4024 27.0047 16.5741 28.0894C16.8213 28.1718 17.3568 28.1718 17.6039 28.0894C20.762 27.0047 29.7967 21.8008 29.7967 12.4091C29.7967 8.74304 26.8309 5.76351 23.1923 5.76351C21.1052 5.76351 19.1692 6.73838 17.9197 8.42724C17.5353 8.949 16.6565 8.949 16.2721 8.42724C14.9951 6.72465 13.0728 5.76351 10.9858 5.76351Z",
    fill: "#171212"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.3a29ab845ff1ba8929d312ea55349564.svg";
export { ForwardRef as ReactComponent };